'use client';

import type { ReactNode } from 'react';
import { useState } from 'react';

import { cn } from '@/lib/ui/utils';

import './morfi-vortex-logo.css';
import {
  MORFI_VORTEX_PATHS,
  MORFI_VORTEX_VIEWBOX_HEIGHT,
  MORFI_VORTEX_VIEWBOX_WIDTH,
  vortexLogoWidthForHeight,
} from './morfi-vortex-wordmark';

interface MorfiVortexLogoProps {
  /** Wordmark height in pixels. Width follows the 387×168 viewBox aspect ratio. Default 32. */
  size?: number;
  className?: string;
  animateOnHover?: boolean;
}

export function MorfiVortexLogo({
  size = 32,
  className,
  animateOnHover = true,
}: MorfiVortexLogoProps): ReactNode {
  const [playing, setPlaying] = useState(false);
  const height = size;
  const width = vortexLogoWidthForHeight(size);

  return (
    <span
      className={cn('morfi-vortex-logo inline-block shrink-0', playing && 'playing', className)}
      aria-hidden
      onMouseEnter={animateOnHover ? () => setPlaying(true) : undefined}
      onAnimationEnd={() => setPlaying(false)}
    >
      <svg
        aria-hidden="true"
        viewBox={`0 0 ${MORFI_VORTEX_VIEWBOX_WIDTH} ${MORFI_VORTEX_VIEWBOX_HEIGHT}`}
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path className="p" d={MORFI_VORTEX_PATHS.m} />
        <path className="p o" d={MORFI_VORTEX_PATHS.o} />
        <path className="p" d={MORFI_VORTEX_PATHS.r} />
        <path className="p" d={MORFI_VORTEX_PATHS.fi} />
      </svg>
    </span>
  );
}
